import { Box } from '@chakra-ui/react';
import { Container, Group, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';

type PlanCardPriceProps = {
  price?: number;
  priceHelperText: string;
};

export const PlanCardPrice = ({ price = 0, priceHelperText }: PlanCardPriceProps) => {
  const { formatCurrency } = useMelioIntl();
  const hasPrice = price > 0;

  return (
    <Container>
      <Group alignItems="center" spacing="xs">
        <Text textStyle="display2Semi">{formatCurrency(price, undefined, { notation: 'compact' })}</Text>
        <Box as="span" textStyle="body4Semi" hidden={!hasPrice}>
          seat /<br /> month
        </Box>
      </Group>
      <Container paddingTop="s">
        <Text textStyle="body4" color="neutral.darker">
          {priceHelperText}
        </Text>
      </Container>
    </Container>
  );
};
